import { render, staticRenderFns } from "./FooterCompanyInfo.vue?vue&type=template&id=ee43d582"
import script from "./FooterCompanyInfo.vue?vue&type=script&lang=js"
export * from "./FooterCompanyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports